import { styled } from "@linaria/react";
import { styleTokens } from "@ideally-ltd/design-tokens";
import { ConfirmPopup } from "primereact/confirmpopup";

const PConfirmPopup = styled(ConfirmPopup)<{ ref: React.LegacyRef<ConfirmPopup> }>`
  .p-popup-header {
    color: ${styleTokens.Surface.Text.sub};
  }
`;

export const PConfirmPopupStyle = {
  PConfirmPopup,
};
